/**
 * Отдать браузеру файл, пришедший из GraphQL строкой base64.
 *
 * Вынесено из `pnlExport.ts` (ТЗ 0075), когда файл понадобился второму
 * разделу — логу участия дофинансированных (ТЗ 0092). `pnlExport.ts`
 * реэкспортирует обе функции, чтобы старые импорты не сломались.
 */

/** base64 (возможно, с переносами строк) → байты файла. */
export const base64ToBytes = (base64: string): Uint8Array => {
  const binary = atob(base64.replace(/\s+/g, ''));
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
};

/**
 * Отдать байты браузеру как файл: Blob → object URL → временная ссылка
 * `<a download>` → клик → URL отзывается. Вне браузера — ничего не делает.
 */
export const saveBytesAsFile = (
  bytes: Uint8Array,
  contentType: string,
  fileName: string,
): void => {
  if (typeof document === 'undefined') return;

  const blob = new Blob([bytes], {
    type: contentType || 'application/octet-stream',
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  try {
    anchor.click();
  } finally {
    document.body.removeChild(anchor);
    // Отзыв откладываем: часть браузеров начинает чтение blob уже ПОСЛЕ
    // синхронного click(), и немедленный revoke обрывает скачивание.
    setTimeout(() => URL.revokeObjectURL(url), 0);
  }
};

export interface IBase64File {
  fileName: string;
  contentType: string;
  contentBase64: string;
}

/** Файл из ответа GraphQL (`fileName` / `contentType` / `contentBase64`). */
export const saveBase64File = (file: IBase64File): void =>
  saveBytesAsFile(
    base64ToBytes(file.contentBase64),
    file.contentType,
    file.fileName,
  );
